export default "https://cdn-static.gokick.com/assets/46c46890c219de5164704b27b734f3ae915944d1/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";